import script from "./SignsureDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignsureDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SignsureDetail.vue?vue&type=style&index=0&id=85106692&lang=less&scoped=true"
import "./SignsureDetail.vue?vue&type=style&index=1&id=85106692&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85106692"]])

export default __exports__